<template>
  <form @submit.prevent="submit()">
    <div v-if="!payload.is_create" dir="ltr" class="is-flex is-align-items-center" style="margin-bottom: 10px;">
      <a @click="generateOffers" class="button is-info">Generate Offers</a>
      <div class="horizontal_space"></div>
      <a @click="sendCVForAdmin" class="button is-info">Send CV For Admin</a>
      <div class="horizontal_space"></div>
      <a v-if="user_id" @click="changePassword" class="button is-info">Change Password</a>
      <div class="horizontal_space"></div>
      <img class="btn" @click="openFilesModal" src="/files_icon.png" width="30px">
      <div class="horizontal_space"></div>
      <img class="btn" @click="openProfileModal" src="/profile_icon.svg" width="30px">
      <div class="horizontal_space"></div>
      <a v-if="user_id" @click="changeUsername" class="button is-info">Edit Username</a>
    </div>
    <div v-if="!payload.is_create" class="router-links">
      <router-link
        :to="{
          name: 'applicant-languages',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Languages</p></router-link
      >
      <a @click="openSkillsModal" class="button is-hovered is-outlined"><p>Skills</p></a>
      <router-link
        :to="{
          name: 'applicant-educations',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Educations</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-history-companies',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>History Companies</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-questions',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Questions</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-texts',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Texts</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-locations',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Locations</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-offers',
          query: {
            applicant_id: payload.data.resource_id,
            statuses: 'awaiting_company,system_strong',
            sort: '-sent_at',
            is_hot_positions: 'true'
          }
        }"
        class="button is-hovered is-outlined"
        ><p>Offers</p></router-link
      >
      <router-link
        :to="{
          name: 'applicant-meetings',
          query: { applicant_id: payload.data.resource_id }
        }"
        class="button is-hovered is-outlined"
        ><p>Meetings</p></router-link
      >
      <a class="button is-hovered is-outlined"><p>Internal Notes</p></a>
    </div>
    <div v-if="form" style="text-align: right; margin-top: 20px;" dir="rtl">
      <div>
        <p class="bold">first_name</p>
        <input
          v-model="form.data.applicant.fields.first_name.value"
          class="outlined full_width"
          placeholder="first_name"
        />
      </div>
      <div>
        <p class="bold">last_name</p>
        <input
          v-model="form.data.applicant.fields.last_name.value"
          class="outlined full_width"
          placeholder="last_name"
        />
      </div>
      <div>
        <p class="bold">phone_number</p>
        <input
          v-model="form.data.applicant.fields.phone_number.value"
          class="outlined full_width"
          placeholder="phone_number"
        />
      </div>
      <div>
        <p class="bold">email</p>
        <input
          v-model="form.data.applicant.fields.email.value"
          class="outlined full_width"
          placeholder="email"
        />
      </div>
      <div class="vertical_space"></div>
      <checkbox
        v-model="form.data.applicant.fields.is_registered.value"
        :checked="form.data.applicant.fields.is_registered.value"
        >is_registered</checkbox
      >
      <div>
        <p class="bold">applicant status</p>
        <select v-model="form.data.applicant.fields.applicant_status.value" dir="rtl">
          <option value="completed">completed</option>
          <option value="vetted">vetted</option>
          <option value="unvetted">unvetted</option>
          <option value="irrelevant">irrelevant</option>
          <option value=""></option>
        </select>
      </div>
      <div>
        <p class="bold">gender</p>
        <select v-model="gender" dir="rtl">
          <option value="female">female</option>
          <option value="male">male</option>
          <option value=""></option>
        </select>
      </div>
      <div>
        <p class="bold">status</p>
        <select v-model="form.data.applicant.fields.status.value" dir="rtl">
          <option value="active">active</option>
          <option value="currently_irrelevant">currently_irrelevant</option>
          <option value="blocked">blocked</option>
          <option value="pending">pending</option>
          <option value="test">test</option>
        </select>
      </div>
      <div>
        <p class="bold">owner</p>
        <input
          v-model="form.data.applicant.fields.owner.value"
          class="outlined full_width"
          placeholder="owner"
        />
      </div>
      <div>
        <p class="bold">message</p>
        <textarea v-model="form.data.applicant.fields.message.value" placeholder="Message"></textarea>
      </div>
      <div class="vertical_space"></div>
      <a v-if="!payload.is_create && !payload.data.blocked" @click="blockApplicant" class="button is-outlined is-danger" :class="{ 'is-loading': is_blocking_applicant }">חסימת מועמד/ת</a>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </form>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import { blockApplicantFlow } from '@/custom/helpers/applicant_block.js'

export default {
  props: ['payload'],
  name: 'admin-applicants-form',
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      is_blocking_applicant: false,
      is_loading: false,
      form: undefined,
      user_id: '',
      genderQuestion: '',
      gender: '',
      applicant_name: this.payload.is_create ? '' : this.payload.data.first_name + ' ' + this.payload.data.last_name,
      owner_name: this.payload.is_create ? this.$utils.getOwner().name : this.payload.data.owner
    }
  },
  created () {
    this.init()
  },
  methods: {
    async blockApplicant () {
      if (this.is_blocking_applicant) {
        return
      }
      // One server-side call: it flags the applicant blocked and adds the Stargate blocklist
      // row in a single transaction; CV files/abstracts are purged afterwards by a worker.
      // Conversations, submissions and history are kept. Release is manager-only.
      this.is_blocking_applicant = true
      try {
        await blockApplicantFlow(this, this.payload.data.resource_id)
      } finally {
        this.is_blocking_applicant = false
      }
    },
    openFilesModal () {
      this.create({ designator: 'applicant-files-modal', component_name: 'Files', applicant_data: this.payload.data, applicant_id: this.payload.data.resource.applicant.resource_id, modal_title: this.applicant_name + ' Files' })
    },
    openProfileModal () {
      this.create({
        designator: 'applicant-profile-modal',
        component_name: 'ApplicantProfilePdf',
        applicant_id: this.payload.data.resource_id,
        modal_title: this.applicant_name + ' - פרופיל מועמד',
        modal_width: 1000,
        is_center_modal: true
      })
    },
    openSkillsModal () {
      this.create({ designator: 'applicant-skill-form-modal', component_name: 'ApplicantSkillsForm', data: this.payload.data, modal_title: this.applicant_name + ' Skills', modal_width: 1300, is_center_modal: true })
    },
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getUser(this.payload.data.id).then(response => {
        this.setForm(response)
        this.$network_utils.getResourceQuestions({
          current_type: 'Applicant',
          current_resource_id: this.payload.data.resource_id,
          designators: 'gender'
        }).then(response => {
          this.genderQuestion = this.questions_helper.getQuestionsWithAnswers(response)[0]
          this.gender = this.genderQuestion.answers.split(',').join('').trim()
        })
      })
    },
    generateOffers () {
      this.$network_utils.postEvent({ current_type: 'Applicant', current_resource_id: this.payload.data.resource_id, event: 'resource_updated', sidekiq_queue: 'high' }).then(() => {
        this.$utils.emit('show_toast', { text: 'מעדכן משרות' })
      })
    },
    sendCVForAdmin () {
      this.$network_utils.postEvent({ current_type: 'Applicant', current_resource_id: this.payload.data.resource_id, event: 'send_cv_for_admin' }).then(() => {
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        applicant: {
          fields: {
            first_name: {
              value: form_data.first_name,
              has_error: false,
              validations: []
            },
            last_name: {
              value: form_data.last_name,
              has_error: false,
              validations: []
            },
            phone_number: {
              value: form_data.phone_number,
              has_error: false,
              validations: []
            },
            email: {
              value: form_data.email,
              has_error: false,
              validations: []
            },
            is_registered: {
              value: form_data.is_registered,
              has_error: false,
              validations: []
            },
            applicant_status: {
              value: form_data.applicant_status,
              has_error: false,
              validations: []
            },
            status: {
              value: form_data.status || 'pending',
              has_error: false,
              validations: []
            },
            message: {
              value: form_data.message,
              has_error: false,
              validations: []
            },
            owner: {
              value: this.owner_name,
              has_error: false,
              validations: []
            },
            resource_type: {
              value: 'Applicant',
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/users/' + form_data.id,
            data: { resource_type: 'Applicant' },
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
      this.user_id = form_data.id
    },
    answerQuestion (params) {
      return this.$network_utils.postQuestionAnswer({
        question_id: params.question_id,
        option_ids: params.option_ids.toString(),
        designator: params.designator,
        current_resource_id: this.payload.data.resource_id,
        current_type: 'Applicant'
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.answerQuestion({
          designator: 'gender',
          question_id: this.genderQuestion.id,
          option_ids: this.genderQuestion.options.find(o => o.text == this.gender).id
        })
        if (this.form.data.applicant.fields.owner.value != this.owner_name) {
          this.$network_utils.postStat({
            designator: 'applicant_owner_changed',
            priority: 5,
            resource_type: 'Applicant',
            resource_id: this.payload.data.resource_id,
            owner: this.$utils.getOwner().name,
            title: 'Applicant Owner Changed',
            content: `${this.$utils.getOwner().name} - שינה את ה owner ל - ${this.form.data.applicant.fields.owner.value}`
          })
        }
        this.remove(this.payload)
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'עודכן בהצלחה' })
      }).catch(() => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'שגיאה' })
      })
    },
    changePassword () {
      this.create({
        modal_title: this.applicant_name + ' - Change Password',
        component_name: 'ChangeUserPasswordForm',
        user_id: this.user_id
      })
    },
    changeUsername () {
      this.create({
        modal_title: this.applicant_name + ' - Change Username',
        component_name: 'ChangeUsernameForm',
        user_id: this.user_id,
        props: {
          username: this.payload.data.username
        }
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    Checkbox
  }
}
</script>
